import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ApiService } from 'app/lib/api.service';
import { LogService } from 'app/lib/log.service';
import * as deepDiff from 'deep-diff';

@Component({
    selector: 'app-view-prevalue-audit',
    templateUrl: './view-prevalue-audit.component.html',
    styleUrls: ['./view-prevalue-audit.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ViewPrevalueAuditComponent implements OnInit {

  Id: any;
  prevJSON: any;
  newJSON: any;

  highlightedPrevJSON!: SafeHtml;
  highlightedNewJSON!: SafeHtml;
  nulldata = false;

  constructor(
    public dialogRef: MatDialogRef<ViewPrevalueAuditComponent>,
    private api: ApiService,
    private log: LogService,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.Id = this.data.data.aId;
  }

  ngOnInit(): void {
    const id = this.Id;

    this.api.get(`audit/getjson/${id}`).subscribe((results: any) => {

      if (!results[0].PrevJSON && !results[0].NewJSON) {
        this.nulldata = true;
        return;
      }

      this.prevJSON = JSON.parse(results[0].PrevJSON);
      this.newJSON = JSON.parse(results[0].NewJSON);

      let prevText = JSON.stringify(this.prevJSON, null, 2);
      let newText = JSON.stringify(this.newJSON, null, 2);

      const diff = deepDiff.diff(this.prevJSON, this.newJSON);

      if (diff) {
        diff.forEach(change => {
          const path = change.path?.join('.') ?? '';

          switch (change.kind) {
            case 'E': // Value Edited
              newText = this.highlightKeyValue(newText, path, change.rhs, 'changed');
              prevText = this.highlightKeyValue(prevText, path, change.lhs, 'deleted');
              break;

            case 'N': // New value added
              newText = this.highlightKeyValue(newText, path, change.rhs, 'added');
              break;

            case 'D': // Value removed
              prevText = this.highlightKeyValue(prevText, path, change.lhs, 'deleted');
              break;
          }
        });
      }

      // DO NOT escape <span> tags — CSS won't work
      this.highlightedPrevJSON = this.sanitizer.bypassSecurityTrustHtml(prevText);
      this.highlightedNewJSON = this.sanitizer.bypassSecurityTrustHtml(newText);
    });
  }

  /** Highlight exact key/value pairs */
  highlightKeyValue(json: string, path: string, value: any, cssClass: string): string {
    const key = path.split('.').pop();
    const formattedValue = JSON.stringify(value);

    const regex = new RegExp(`("${key}"\\s*:\\s*)${formattedValue}`, 'g');

    return json.replace(
      regex,
      `$1<span class="${cssClass}">${formattedValue}</span>`
    );
  }

  onClose() {
    this.dialogRef.close();
  }
}
